
import TableList from "@components/templates/tablelist";
import compUpdate from "./update.vue";
import {
    HttpWarehouseCarrierList,
    HttpActiveWarehouseCarrier,
    HttpTruckLogAllList
} from "@/service/carrieraccount.js";
import { HttpGetAllServiceList, HttpGetAllServiceProductList } from "@/service/fedex";
import { mapState, mapGetters } from "vuex";
import mixin from '../mixin';
export default {
    mixins: [TableList, mixin],
    components: {
        compUpdate,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                }
            },
            Searchs: {
                show: true,
                labelWidth: 100,
            },
            datename: '',
            datetime: '',
            Plugins: { show: true },
            initData: '',
            truckCarrierGroupList: [],
            serviceProductList: [],
        };
    },
    created() {
        this.getServiceProductList();
        HttpTruckLogAllList().then(res => {
            this.truckCarrierGroupList = res.data.map((item) => {
                return {
                    label: item.code + '(' + item.carrierServiceName + ')',
                    value: item.code,
                    attach: {
                        type: item.type,
                    },
                };
            });
        }, err => {
            this.$VMessage.error(err.message)
        })
    },
    methods: {
        ajaxRequest: HttpWarehouseCarrierList,
        exportQuery() {
            let searchData = {}
            Object.keys(this.formData.search).map(item => {
                console.log(item, this.formData.search[item])
                searchData[`search[${item}]`] = this.formData.search[item]
            });
            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/WarehouseCarrierService/batchExport", {
                ...searchData
            }, {
                executor: 'request',
                download: true,
            }).catch(err => {
                // this.$VMessage.error(err.message);
            });
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.selectdata', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'query':
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 800,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case 'exportQuery':
                    this.exportQuery(params);
                    break
                case 'add':
                    this.operate = {
                        title: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                        show: true,
                        width: 600,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'add',
                        showFooter: false
                    }
                    break;
                case 'edit':
                    this.operate = {
                        title: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                        show: true,
                        width: 600,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'edit',
                        showFooter: false
                    }
                    break;
                case 'active':
                    this.operate = {
                        title: params.status === 0 ? this.$t('fbb.accountmanage.loss_effect', { defaultValue: '失效' }) : this.$t('fbb.accountmanage.active', { defaultValue: '启用' }),
                        show: true,
                        alert: 'warning',
                        width: 400,
                        showDesc: true,
                        params: {
                            id: params.id
                        },
                        ajaxRequest: HttpActiveWarehouseCarrier,
                    };
                    break;
                case "import":
                    this.operate = {
                        show: true,
                        title: '导入',
                        width: 460,
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_FBB + "/api/v2/WarehouseCarrierService/importOrder",
                        name: "multipartFile",
                        component: "compUpload",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/WarehouseCarrierService/itemTemplate", {}, 'download');
                        },
                        on: {
                            "on-success": () => {
                                this.$emit('on-close');
                                this.$emit('on-update');
                            }
                        }
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row
            return [
                {
                    label: this.$t('global.common.query', { defaultValue: '查看' }),
                    show: true,
                    params: id,
                    operate: 'query'
                },
                {
                    label: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                    show: this.handleAuth('fbb.warehouseservice.edit'),
                    params: id,
                    operate: 'edit'
                }, {
                    label: row.status === 0 ? this.$t('fbb.accountmanage.loss_effect', { defaultValue: '失效' }) : this.$t('fbb.accountmanage.active', { defaultValue: '启用' }),
                    show: this.handleAuth('fbb.warehouseservice.edit'),
                    params: {
                        id,
                        status: row.status
                    },
                    operate: 'active'
                }]
        },
        getServiceProductList(){
            HttpGetAllServiceProductList().then(
                (res) => {
                    this.serviceProductList = res.data.map(item => {
                        return {
                            value: item.code,
                            label: item.code,
                            attach: item,
                        };
                    });
                },
                (err) => {
                    this.$Message.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
    },
    computed: {
        ...mapGetters("dictionary", [
            "getCarrierAllList",
            "getBillcusWareList",
            "getAlllogProCodeList",
            'getCustomServiceProductAllList',
        ]),
        ToolsData() {
            return [
                {
                    name: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                    operate: "add",
                    show: this.handleAuth('fbb.warehouseservice.add'),
                    theme: "primary",
                },
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: 'exportQuery',
                    show: this.handleAuth('fbb.warehouseservice.export'),
                    theme: 'success'
                },
                {
                    name: "导入",
                    operate: "import",
                    show: true,
                    theme: "success"
                }
            ]
        },
        SearchsData() {
            let widthStyle = 'width: 250px'
            return [
                {
                    label: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                    tag: 'Select',
                    key: 'EQ_warehouseId',
                    show: true,
                    options: this.getBillcusWareList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: '仓库服务代码',
                    tag: 'Input',
                    key: 'EQ_carrierServiceApiCode',
                    show: true,
                },
                {
                    label: this.$t('erp.b2c.hippingMethodCode', { defaultValue: '物流服务' }),
                    tag: 'Select',
                    key: 'IN_carrierServiceCode',
                    show: true,
                    // options: this.truckCarrierGroupList,
                    // options: this.serviceProductList,
                    options: this.getCustomServiceProductAllList.map(item=>{
                        return {
                            value: item.attach.code,
                            label: item.label,
                        }
                    }),
                    props: {
                        filterable: true,
                        clearable: true,
                        multiple: true
                    }

                },

                {
                    label: '状态',
                    tag: 'Select',
                    key: 'EQ_status',
                    options: [
                        { value: 0, label: 'Active' },
                        { value: 1, label: 'InActive' },
                    ],
                }
            ]
        },
        columns() {
            return [
                {
                    // show: false,
                    type: 'index',
                    width: 40,
                    align: 'center',
                }, {
                    title: this.$t('global.common.actions', { defaultValue: '操作' }),
                    width: 70,
                    render: this.getOperateNodes,
                },
                {
                    title: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                    key: 'warehouseName',
                    render: (h, { row }) => {
                        return <div>{this.findRenderLabel(this.getBillcusWareList, row.warehouseId || '--')}</div>
                    }
                },
                // {
                //     title: this.$t('fbb.carrieraccount.carrier_group', { defaultValue: '物流产品' }),
                //     key: 'groupName',
                // },
                {
                    title: this.$t('erp.b2c.hippingMethodCode', { defaultValue: '物流服务' }),
                    key: 'carrierServiceCode',
                    // render: (h, { row }) => {
                    //     return <div>{row.carrierServiceCode}({row.carrierServiceName})</div>
                    // }
                },
                {
                    title: '仓库服务代码',
                    key: 'carrierServiceApiCode'
                },
                {
                    title: this.$t('global.common.status', { defaultValue: '状态' }),
                    render: (h, { row }) => {
                        return <div>{row.status === 0 ? 'Active' : 'InActive'}</div>
                    }
                },
                {
                    title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                    // width: 130
                }
            ];
        },

    }

};
